import * as UI from "@iyk/ui"

import { Link, Routes } from "./link.tsx"

export const ShortUserProfileCard = (props: ShortUserProfileCard.Props) => {
  return (
    <Link
      to={Routes.collection(props.userId)}
      className="flex justify-between pl-3 pr-2 py-2.5 rounded border border-white/[10%] bg-white/[3%]"
    >
      <span className="text-xs-departure content-center">{props.username}</span>
      <div className="flex justify-between items-center gap-2">
        <div className="flex items-center gap-1 px-1.5 py-0.5 rounded-sm bg-[var(--grayA-2,rgba(255,255,255,0.04))] border-[0.5px]  border-[var(--grayA-3,rgba(255,255,255,0.07))]">
          <UI.Icon.Proof className="size-2.5" />
          <span className="text-xs-departure">{props.totalProofs}</span>
        </div>
        <span className={UI.classForButton({ size: "sm", kind: "ghost" })}>
          <UI.Icon.Eye />
        </span>
      </div>
    </Link>
  )
}

namespace ShortUserProfileCard {
  export type Props = {
    userId: string
    username: string
    totalProofs: number
  }
}
